import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Signup from './components/Signup';
import './App.css';

function App() {
  const [auth, setAuth] = useState({
    isAuthenticated: false,
    user: null,
    loading: true
  });

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    
    if (token && user) {
      // Set auth headers for all future requests
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      setAuth({
        isAuthenticated: true,
        user,
        loading: false
      });
    } else {
      setAuth({
        isAuthenticated: false,
        user: null,
        loading: false
      });
    }
  }, []);

  // Protected route component
  const ProtectedRoute = ({ children }) => {
    if (auth.loading) return <div>Loading...</div>;
    
    if (!auth.isAuthenticated) {
      return <Navigate to="/login" />;
    }
    
    return children;
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={
            auth.isAuthenticated ? <Navigate to="/dashboard" /> : <Login setAuth={setAuth} />
          } />
          <Route path="/signup" element={
            auth.isAuthenticated ? <Navigate to="/dashboard" /> : <Signup setAuth={setAuth} />
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard user={auth.user} setAuth={setAuth} />
            </ProtectedRoute>
          } />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;